/* eslint semi:0 */
import { isNativeApp, } from 'utils/ua'
import { registerUtils, } from 'application/nm'
import cooladata from './cooladataScript'
import taboola from './taboolaScriptConfig'
import headerBidder from './headerBidderScriptConfig'
import { queryString, } from 'utils/window'
import { warn, } from 'application/console'
import { noop, makeSafeFn, } from 'utils/fn'
import facebookPixel from './facebookPixelScript'
import { iterate as iterateObject, } from 'utils/object'
import {
  get as getFromPdo,
  isEmbededPost,
  isTopX,
  isSlideshow,
  isHybrid,
} from 'application/pageDataObject'
import { browsiScriptConfig as browsi } from './browsiScriptConfig'
import { ready as onGoogleSearchActionsReady, } from 'actions/googleSearchActions'

const w = window
const { noBcScript, a_aid: affiliateId, } = queryString
const fullMasterDomainUrl = "http://www.90min.com/"

const JWPLAYER_PLAYERID = 'xuiMA8L7';

const externalScriptsConfig = {

  facebookPixel,
  cooladata,
  browsi,

  googleAnalytics: {
    src: '//www.google-analytics.com/analytics.js',
    beforeLoad(){
      w.GoogleAnalyticsObject = 'ga'
      const ga = w.ga = w.ga || function setGoogleAnalyticsQ(){
        (ga.q = ga.q || []).push(arguments)
      }
      ga.l = 1 * new Date()
      ga('create', getFromPdo('config.google_analytics.account_id'), 'auto')
      // for double-click: https://support.google.com/analytics/answer/3450482
      ga('require', 'displayfeatures')
    },
  },

  comscore: { src: '//b.scorecardresearch.com/beacon.js', },
  quantcast: { src: '//edge.quantserve.com/quant.js', },
  agof: { src: '//script.ioam.de/iam.js', },

  facebook: {
    src: `//connect.facebook.net/${ getFromPdo('config.facebook.sdk_locale', 'en_US') }/sdk.js`,
    onload: makeSafeFn(function onFacebookSdkLoaded(){
      w.FB.init({
        appId: getFromPdo('config.facebook.app_id'),
        version: getFromPdo('config.facebook.api_version'),
        cookie: true,
        xfbml: true
      })
    }),
  },

  outbrain: { src: '//widgets.outbrain.com/outbrain.js', },
  twitter: { src: '//platform.twitter.com/widgets.js', },
  riddle: { src: '//www.riddle.com/files/js/embed.js', },

  googleSearch: {
    src: `//www.google.com/cse/cse.js?cx=${ getFromPdo('config.google_search.cx') }`,
    beforeLoad(){
      w.__gcse = { callback: onGoogleSearchActionsReady, }
    },
  },

  taboola,
  headerBidder,

  dfp: {
    src: '//www.googletagservices.com/tag/js/gpt.js',
    beforeLoad(){
      const inAppConditions = isHybrid &&
        !isEmbededPost && !affiliateId &&
        !isTopX && !isSlideshow;
      return isNativeApp ? inAppConditions : true;
    },
  },

  brightcove: {
    src: 'http://admin.brightcove.com/js/BrightcoveExperiences.js',
    beforeLoad(){
      return !noBcScript
    },
  },

  jwplayer: {
    src: `//content.jwplatform.com/libraries/${JWPLAYER_PLAYERID}.js`
  },

  oneSignal: {
    src: 'https://cdn.onesignal.com/sdks/OneSignalSDK.js',
    onload(){
      const oneSignal = w.OneSignal = w.OneSignal || []
      oneSignal.push([
        "init",
        {
          appId: getFromPdo('config.onesignal.app_id', ''),
          subdomainName: getFromPdo('config.onesignal.subdomain', ''),
        },
      ])
    },
  },

  teads: {
    src: `//as.ebz.io/api/choixPubJS.htm?pid=1128016&screenLayer=1&mode=NONE&home=${ getFromPdo(fullMasterDomainUrl, w.location.host) }`,
  },

  playbuzz: { src: '//cdn.playbuzz.com/widget/feed.js', },

  scribblelive: {
    id: 'scrbbl-js',
    src: '//embed.scribblelive.com/widgets/embed.js',
  },

  newscorp: {
    src: '//www.ballball.com/static/js/enhanced_player/1.1/enhanced_player_host.js',
  },

  pingdomRum: {
    src: '//rum-static.pingdom.net/prum.min.js',
    beforeLoad(){
      w._prum = [
        ['id', '556ace35abe53d98071704a4', ],
        ['mark', 'firstbyte', (new Date()).getTime(), ],
      ]
    },
  },

  perimeterX: {
    src: '//client.a.pxi.pub/PXszbKVa5M/main.min.js',
    beforeLoad(){
      Object.assign(w, {
        _pxAppId: 'PXszbKVa5M',
        _pxParam1: affiliateId,
        _pxPubHost: 'collector.a',
      })
    },
  },

  jQuery: { src: '//code.jquery.com/jquery-2.1.4.min.js', },
}

const SCRIPT_LOADER_CONF_DEFAULTS = {
  defer: true,
  onload: noop,
  beforeLoad(){ return true },
}


function addNamePropertyToScriptConf(scriptConf, scriptName){
  const scriptConfName = scriptConf.name || scriptName
  const { src, } = scriptConf
  if (!src) {
    const falsySrcErrorMessage =
      `Falsy src ('${ src }') in scriptConf name '${ scriptConfName }'!`
    warn(falsySrcErrorMessage, { scriptConf, scriptConfName, })
  }
  scriptConf.name = scriptConfName
}

Object.assign(
  iterateObject(externalScriptsConfig, addNamePropertyToScriptConf),
  { defaults: SCRIPT_LOADER_CONF_DEFAULTS, }
)

registerUtils({ externalScriptsConfig, })

export default externalScriptsConfig


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/config/externalScripts.js